export default __webpack_public_path__ + "static/media/icon_notifications.7e3ecfbe.svg";